// @flow
import React from 'react';
import styled from 'react-emotion';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiRadio from '@material-ui/core//Radio';
import consts, { colors, doors } from '../assets/scripts/constants';

/**
 * Styles
 */

const Wrapper = styled('span')`
  flex-basis: ${({ color, door }) => (color || door) && '33.3%'};
  margin-top: -1.6em;
  margin-bottom: ${({ color }) => color && `${2.5 * consts.cell}em`};
  margin-bottom: ${({ door }) => door && `${5.8 * consts.cell}em`};

  > label {
    position: relative;
    margin-right: ${({ color, door }) => (color || door) && 0};

    &::after {
      display: block;
      content: ${({ color }) => color && "''"};
      content: ${({ door }) => door && `url('${doors[door]}')`};
      position: absolute;
      left: ${({ color }) => (color ? '5em' : '1.9em')};
      bottom: -50%;
      width: 3.1em;
      height: 3.1em;
      background: ${({ color }) => colors[color]};
      border-radius: 10em;
    }

    > span:nth-of-type(2) {
      margin-left: -0.6em;
      font-size: 1.6em;
    }

    > span > span > svg {
      transform: scale(0.6);
    }
  }
`;

/**
 * Component: Radio
 *
 * Modifies the MaterialUI Radio button for our convenience.
 */
function Radio(props: {
  color?: string,
  door?: string,
  label: string,
  value: string,
}) {
  return (
    <Wrapper color={props.color} door={props.door}>
      <FormControlLabel {...props} control={<MuiRadio color="secondary" />} />
    </Wrapper>
  );
}

Radio.defaultProps = {
  color: '',
  door: '',
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Radio.js